<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="0">
        <v-icon left>mdi-office-building</v-icon>
        <v-toolbar-title>System Configuration - Building</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'buildings-toolbar',
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>